module.exports = __webpack_public_path__ + "static/img/020 11.98d1d7e5.jpg";